import { render, staticRenderFns } from "./QualificationFormDialog.vue?vue&type=template&id=24c1a984&"
import script from "./QualificationFormDialog.vue?vue&type=script&lang=js&"
export * from "./QualificationFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports